import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveContactPayload } from "../types/contactType";

export const getContactList = createAsyncThunk("/contact/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/contacts?${query.toString()}`)).data;
  return response;
});

export const saveContact = createAsyncThunk("/contact/save", async (payload: SaveContactPayload) => {
  const response = (await api.post("/contacts/action", payload)).data;
  return response;
});

export const deleteContact = createAsyncThunk("/contact/delete", async (id: number) => {
  const response = (await api.get(`/contacts/delete/${id}`)).data;
  return response;
});
